import { ref } from 'vue'
import { until } from '@vueuse/core'

export const wait = async(duration: number, callback: () => void) => {
    const source = ref(true)
    await until(source).toBe(false, { timeout: duration })
    callback()
}